import {useCallback} from 'react';
import VectorIcon from '../VectorIcon';
import ReactModal from 'react-modal';
import {MemberCollectedProductType} from '../../types/backend';
import MemberCollectedProductForm from '../forms/MemberCollectedProductForm.client';

interface EditMemberCollectedProductModalProps {
  uuid: string;
  isProductRequest: boolean;
  isOpen: boolean;
  onRequestClose: () => void;
  onSuccess?: (memberCollectedProduct: MemberCollectedProductType) => void;
  loading?: boolean;
  isNewRecord?: boolean;
}

export default function EditMemberCollectedProductModal({
  uuid,
  isProductRequest,
  isOpen,
  onRequestClose,
  onSuccess,
  loading = false,
  isNewRecord = false,
}: EditMemberCollectedProductModalProps) {
  const handleSuccess = useCallback(
    (memberCollectedProduct: MemberCollectedProductType) => {
      onSuccess?.(memberCollectedProduct);
      onRequestClose();
    },
    [onRequestClose, onSuccess],
  );

  return (
    <ReactModal
      isOpen={isOpen}
      className="modal__content default-modal default-modal-large"
      overlayClassName="modal modal_active"
      shouldCloseOnOverlayClick={true}
      onRequestClose={onRequestClose}
      closeTimeoutMS={300}
    >
      <div
        className="default-modal__close close js-modal-close"
        role="button"
        tabIndex={-1}
        onClick={onRequestClose}
      >
        <VectorIcon iconName="delete-x" />
      </div>
      <div className="default-modal__box">
        <MemberCollectedProductForm
          uuid={uuid}
          onSuccess={handleSuccess}
          isProductRequest={isProductRequest}
          isNewRecord={isNewRecord}
        />
        {loading && (
          <div className="overlay">
            <div className="loading" />
          </div>
        )}
      </div>
    </ReactModal>
  );
}
